import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import toDecimalPlaces from "src/lib/to-decimal-places";
import Stars from "src/react/components/stars";

function ProductStars({ rating, reviewCount }) {
  return (
    <ProductStarsWrapper>
      {!!rating && (
        <Fragment>
          <Stars value={rating} starSize={25} />
          <Text>
            ({toDecimalPlaces(rating, 1)} stars, {reviewCount} reviews)
          </Text>
        </Fragment>
      )}
    </ProductStarsWrapper>
  );
}

ProductStars.propTypes = {
  rating: PropTypes.number,
  reviewCount: PropTypes.number,
};

export default ProductStars;

const ProductStarsWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  min-height: 37px;
`;

const Text = styled.p`
  font-size: 14px;
  margin-left: 10px;
  margin-bottom: 0;
`;
